export const BASE_URL = process.env.BASE_URL;

export var API_TOKEN = localStorage.getItem('marsb-token');
export function headers() {
  //console.log('API token is ' + API_TOKEN);
  if (API_TOKEN != null && API_TOKEN.length > 0) {
    return { headers: { accesstoken: API_TOKEN } };
  } else {
    API_TOKEN = localStorage.getItem('marsb-token');
    //console.log('token ' + API_TOKEN);
    if (API_TOKEN != null && API_TOKEN.length > 0) {
      return { headers: { accesstoken: API_TOKEN  } };
    } else {
      return { headers: {} };
    }
  }
}
export function outputError(error) {
  console.log(JSON.stringify(error));
}
export function updateAPIToken(token) {
  API_TOKEN = token;
}


// WEBPACK FOOTER //
// ./src/api/token.js